'use strict';

angular.module('app.updateReferencePoints', [])
	.controller('updateReferencePointsCtrl', ['$scope', '$modalInstance', '$modal', 'updateReferencePointsService',
		function ($scope, $modalInstance, $modal, updateReferencePointsService) {
    
		    $scope.confirmUpdateReferencePoints = function () {
		        $scope.selectedPeriod = "";
		        angular.forEach($scope.period, function (item) {
		            if (item.ticked == true) {
		                $scope.selectedPeriod = item;
		            }
		        })

		        var params = {
		            data: $scope.referencePoints,
		            month: $scope.selectedPeriod.value
		        }

		        updateReferencePointsService.updateReferencePoints(params, true)
		        	.then(function(response) {
		        		$modalInstance.close(function () {
			                $log.info('Close Modal now');
			            })
		        	}, function(response) {
		        		var errorModalInstance = $modal.open({
	                        scope: $scope,
	                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
	                        windowClass: 'modal-dialog-mention-error'
	                    });
	                    $scope.errorModalInstance = errorModalInstance;
	                    $scope.errorMessage = response.message;
		        	})
		    }
		    
		    $scope.closeModal = function(){
		        $modalInstance.close();    
		    }
}])